import AppHeader from "../../layout/AppHeader";
import PriceTable from '../../xpost/views/financial/price/PriceTable.vue';
import PriceTableAdd from '../../xpost/views/financial/price/PriceTableAdd.vue';
import PriceTableImport from '../../xpost/views/financial/price/PriceTableImport.vue';

const PriceTableRoutes = [
    {
        path: "/cadastro/tabelapreco",
        name: "price.table",
        components: {
            header: AppHeader,
            default: PriceTable,
        }
    },
    {
        path: "/cadastro/tabelapreco/adicionar",
        name: "price.table.add",
        components: {
            header: AppHeader,
            default: PriceTableAdd,
        }
    },
    {
        path: "/cadastro/tabelapreco/importar",
        name: "price.table.import",
        components: {
            header: AppHeader,
            default: PriceTableImport,
        }
    },
    {
        path: '/cadastro/tabelapreco/adicionar/:packagetable/:servicegroup',
        name: 'price.table.edit',
        components: {
            header: AppHeader,
            default: PriceTableAdd,
        }
    }
]

export default PriceTableRoutes;